import { Search } from "lucide-react";
import type { JsonRecord } from "../../types";
import { ExecutionCivilDateInput } from "./ExecutionCivilDateInput";

export interface ExecutionFiltersValue {
  start: string;
  end: string;
  frontId: string;
  subfrontId: string;
  search: string;
}

const id = (row: JsonRecord) => String(row.id || row.frente_id || row.subfrente_id || "");
const name = (row: JsonRecord) => String(
  row.frente
  || row.subfrente
  || row.nombre
  || row.codigo
  || row.label
  || "Sin nombre",
);

export function ExecutionFilters({
  value,
  fronts,
  subfronts,
  onChange,
  onApply,
}: {
  value: ExecutionFiltersValue;
  fronts: JsonRecord[];
  subfronts: JsonRecord[];
  onChange: (value: ExecutionFiltersValue) => void;
  onApply: () => void;
}) {
  const scopedSubfronts = subfronts.filter(
    (row) => !value.frontId || String(row.frente_id || "") === value.frontId,
  );
  const set = (patch: Partial<ExecutionFiltersValue>) => onChange({ ...value, ...patch });

  return <form
    className="execution-filters"
    onSubmit={(event) => {
      event.preventDefault();
      onApply();
    }}
  >
    <label>
      Fecha desde
      <ExecutionCivilDateInput
        ariaLabel="Fecha desde"
        max={value.end || undefined}
        value={value.start}
        onChange={(start) => set({ start })}
      />
    </label>
    <label>
      Fecha hasta
      <ExecutionCivilDateInput
        ariaLabel="Fecha hasta"
        min={value.start || undefined}
        value={value.end}
        onChange={(end) => set({ end })}
      />
    </label>
    <label>
      Frente
      <select
        value={value.frontId}
        onChange={(event) => set({ frontId: event.target.value, subfrontId: "" })}
      >
        <option value="">Todos los frentes</option>
        {fronts.map((row) => <option key={id(row)} value={id(row)}>{name(row)}</option>)}
      </select>
    </label>
    <label>
      Subfrente
      <select
        disabled={!value.frontId}
        value={value.subfrontId}
        onChange={(event) => set({ subfrontId: event.target.value })}
      >
        <option value="">
          {value.frontId ? "Todos los subfrentes" : "Selecciona un frente"}
        </option>
        {scopedSubfronts.map((row) => <option key={id(row)} value={id(row)}>{name(row)}</option>)}
      </select>
    </label>
    <label className="execution-search">
      Buscador general
      <span className="search-box">
        <Search size={16} />
        <input
          value={value.search}
          placeholder="Buscar en los datos visibles…"
          onChange={(event) => set({ search: event.target.value })}
        />
      </span>
    </label>
    <button
      className="button secondary"
      type="submit"
      disabled={Boolean(value.start && value.end && value.end < value.start)}
    >
      Aplicar filtros
    </button>
  </form>;
}
